<template lang="pug">

tr

    //- Auftraggeber
    //- Auftraggeber nur anzeigen, wenn Benutzer "zmuekish" ist
    td(v-if='$auth.isZmuekish') {{ purchaserName }}

    //- MP
    td {{ mediaProductionName }}

    //- Produkt-ID
    td {{ productModel.zmuekId }}

    //- Name Optional: (v-bind:to='toViewRoute' target="_blank")
    td
        router-link(v-bind:to='toViewRoute')  {{ productModel.name }}

    //- Type
    td(v-tooltip='productTypeName')  {{ productTypeName | truncate(20) }}

    //- Kampagne
    td(v-tooltip='campaignName') {{ campaignName | defaultTo('-') | truncate(20)  }}

    //- Varianten
    td
        variants(v-bind:variant-models='variantModels')

    //- DU an DuW
    td {{ printingMaterialToZmuek }}

    //- Liefertermin
    td {{ deliveryDate }}

    //- Eingestellt
    td {{ createdDate }}

    //- Action
    td.right.aligned
        product-action-dropdown(
            compact
            icon='ellipsis vertical'
            v-bind:product-model='productModel'
            v-bind:variant-models='variantModels'
            v-bind:show-edit-link='true'
        )

</template>

<script>
    import * as R from 'ramda'
    import { to_ddmmyyyy, string_to_readable as string_to_readable_date } from '@/utils/date'
    import Variants from './Variants'
    import ProductActionDropdown from '@/components/products/ProductActionDropdown'

    //noinspection JSUnusedGlobalSymbols
    export default {
        name: 'products-table-row',

        components: { Variants, ProductActionDropdown },

        computed: {

            campaignModel() {
                return R.compose(

                    // Kampagne mit ID finden
                    campaignId => R.find(R.propEq('id', campaignId), this.campaignModels),

                    // Kampagnen-ID ermitteln
                    R.prop('campaign')

                )(this.productModel)
            },



            campaignName() {
                return R.prop('name', this.campaignModel)
            },

            createdDate() {
                return to_ddmmyyyy(this.productModel.createdDate)
            },

            deliveryDate() {
                return string_to_readable_date(this.productModel.deliveryDate)
            },

            mediaProductionPerson() {
                return R.compose(

                    // Person mit ID finden
                    personId => R.find(R.propEq('id', personId), this.mediaProductionPersonModels),

                    // Personen-ID holen
                    R.prop('person')

                )(this.mediaProductionUser)
            },

            mediaProductionUser() {
                return R.compose(

                    // Benutzer mit ID finden
                    userId => R.find(R.propEq('id', userId), this.mediaProductionUserModels),

                    // Benutzer-ID des Medienproduktioners holen
                    R.prop('mediaProduction')

                )(this.productModel)
            },

            mediaProductionName() {
                return R.compose(

                    // Namen zusammensetzen
                    R.join(' '),

                    // Vor- und Nachnamen einlesen
                    R.props(['firstName', 'lastName']),

                    // ggf. leere Default-Person zurueckgeben
                    R.defaultTo({}),

                )(this.mediaProductionPerson)
            },

            printingMaterialToZmuek() {
                return R.compose(

                    // ggf. Defaultwert zurueckgeben
                    R.defaultTo('-'),

                    // Datum formatieren
                    to_ddmmyyyy,

                    // Datum einlesen
                    R.prop('printingMaterialToZmuek')

                )(this.productModel)
            },

            toViewRoute() {
                return {
                    name: 'products/view',
                    params: {
                        id: this.productModel.id,
                        variantId: R.path([0, 'id'], this.variantModels)
                    }
                }
            },

            productTypeName() {
                return R.compose(

                    // Typ-Namen einlesen
                    R.propOr('-', 'name'),

                    // Produkt-Typ holen
                    this.$store.getters['productTypes/byId'],

                    // Type-ID einlesen
                    R.prop('type')

                )(this.productModel)
            },

            purchaserName() {
                return R.compose(

                    // Unternehmensnamen einlesen
                    R.propOr('-', 'name'),

                    // Unternehmen holen
                    this.$store.getters['companies/byId'],

                    // Unternehmens-ID einlesen
                    R.prop('company')

                )(this.productModel)
            },

        },

        methods: {},

        created() {
            R.compose(

                // Wenn ID vorhanden, Produkttype laden
                R.when(
                    R.is(Number),
                    id => this.$store.dispatch('productTypes/loadOne', { id })
                ),

                // Typ-ID lesen
                R.prop('type')

            )(this.productModel)

        },

        props: {

            campaignModels: {
                type: Array,
                required: true
            },

            mediaProductionPersonModels: {
                type: Array,
                required: true
            },

            mediaProductionUserModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            }

        },

    }

</script>
